import { create } from 'zustand';
import type { Micro, TxRecord } from '@shared/chain';

export interface WalletState {
  balanceMicro: Micro;
  faucetClaimed: boolean;
  txs: TxRecord[];
  loading: boolean;
  setLoading(l: boolean): void;
  setBalance(b: Micro): void;
  setFaucetClaimed(v: boolean): void;
  setTxs(txs: TxRecord[]): void;
  addTx(tx: TxRecord): void;
  reset(): void;
}

function dedupe(list: TxRecord[], incoming: TxRecord[]): TxRecord[] {
  const map = new Map<string, TxRecord>();
  for (const t of list) map.set(t.txHash, t);
  for (const t of incoming) map.set(t.txHash, t);
  return [...map.values()].sort((a, b) => b.timestamp - a.timestamp);
}

export const useWalletStore = create<WalletState>((set) => ({
  balanceMicro: '0',
  faucetClaimed: false,
  txs: [],
  loading: false,
  setLoading: (l) => set({ loading: l }),
  setBalance: (b) => set({ balanceMicro: b }),
  setFaucetClaimed: (v) => set({ faucetClaimed: v }),
  setTxs: (txs) => set({ txs: dedupe([], txs) }),
  addTx: (tx) => set((s) => ({ txs: dedupe(s.txs, [tx]) })),
  reset: () => set({ balanceMicro: '0', faucetClaimed: false, txs: [], loading: false }),
}));

export default useWalletStore;
